import Request from '../../request';
const BASE_URI_GO_API = process.env.API_GO_URL + '/api/v1/usuario';

const GetUserByEmail = async (id) => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/email/${id}`)
}

export default {GetUserByEmail}



// WEBPACK FOOTER //
// ./src/services/api/user/index.js